import styled from 'styled-components';

export const MatchDatumlLink = styled.a`
  text-transform: inherit;
  margin: 0;
  line-break: anywhere;
`;

export const matchStyle = {
  backgroundColor: 'var(--cl-yellow-300)',
  padding: '4px 6px',
  borderRadius: '4px',
};
